import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FinalReviewRow from './FinalReviewRow';
import ShowIf from '../../../../../SharedComponents/ShowIf/ShowIf';
import { showModal } from '../../../../../reducers/modals/modalsActions';
import ConfirmationModal from '../../../../../SharedComponents/Modals/ConfirmationModal/ConfirmationModal';

import { saveHeaderIndexRevOrder } from '../../../../../reducers/header/headerActions';
import LoaderModal from '../../../../../SharedComponents/Modals/LoaderModal/LoaderModal';
import useReviewOrder from '../ReviewOrder/useReviewOrder';
import useShoppingCart from '../../../../../SharedComponents/ShoppingCart/useShoppingCart';
import { spinner } from '../../../../../reducers/userInterface/userInterfaceActions';
import AlertModal from '../../../../../SharedComponents/Modals/AlertModal/AlertModal';



const FinalReview = () => {


    const headerIndex = useSelector(({ header }) => header.index)
    const history = useHistory();
    const valuesCheckout = useSelector(({ reviewOrder }) => reviewOrder.values)
    // const valuesCheckout = JSON.parse(`{"cartList":[{"caseQuantity":3,"price":30.843,"itemDistributorId":890776,"brand":"Chefs Quality","brandImageUrl":"https://diningalliance.s3.amazonaws.com/brand/Chefs%20Quality.jpg","imageUrl":"https://diningalliance.s3.amazonaws.com/itemdistributor/CHEFS%20QUALITY%20PINEAPPLE%20CHUNKS%20IN%20NATURAL%20SAUCE%20-%206/%2310%20CANS-890776.jpg","name":"chef quality pineapple chunk l/ #10","packSize":"6/10LB","status":"active","type":"non_order_guide","unitPrice":0.51405,"distributorId":531,"unitMeasure":"cs","description":"chef quality pineapple chunk l/ #10","searchText":null,"rebate":null,"swapAcceptId":null,"isSpecialItem":false,"distributor":"FoodBAM- GI","shoppingCartId":1148311,"isPriceOutdated":0,"isMarketPrice":0,"din":"2340138 ","isPunchedOut":0,"belongsToGroup":1,"parLevel":null,"onHand":null,"isPartner":1,"isPurchased":1,"lastPurchasedDate":"17/02/2020","lastPurchasedQty":2,"savings":null,"priceTotalRow":"$92.53"},{"caseQuantity":7,"price":17.25,"itemDistributorId":5242921,"brand":"Chefs Quality","brandImageUrl":"https://diningalliance.s3.amazonaws.com/brand/Chefs%20Quality.jpg","imageUrl":"https://diningalliance.s3.amazonaws.com/item/CHEFS%20QUALITY%20MARASCHINO%20CHERRIES%20%28LARGE%29%20WITH%20STEMS%20-%201/128%20OZ.jpg","name":"chef s quality cherries large with stems chefs","packSize":"1/128EA","status":"active","type":"non_order_guide","unitPrice":0.13478,"distributorId":531,"unitMeasure":"ea","description":"chef s quality cherries large with stems chefs","searchText":null,"rebate":null,"swapAcceptId":null,"isSpecialItem":false,"distributor":"FoodBAM- GI","shoppingCartId":1148305,"isPriceOutdated":0,"isMarketPrice":0,"din":"38001 ","isPunchedOut":0,"belongsToGroup":1,"parLevel":null,"onHand":null,"isPartner":1,"isPurchased":1,"lastPurchasedDate":"17/02/2020","lastPurchasedQty":9,"savings":null,"priceTotalRow":"$120.75"},{"caseQuantity":1,"price":9.338,"itemDistributorId":5243079,"brand":"Chef Mate","brandImageUrl":"https://foodbam-east.s3.amazonaws.com/brand/Chef%20Mate.jpg","imageUrl":"https://foodbam-east.s3.amazonaws.com/itemdistributor/CHEF%20MATE%20CHEDDAR%20CHEESE%20SAUCE%20%2310-5243079.jpg","name":"chef mate cheddar cheese sauce #10","packSize":"1/10LB","status":"active","type":"non_order_guide","unitPrice":0.9338,"distributorId":531,"unitMeasure":"ea","description":"chef mate cheddar cheese sauce #10","searchText":null,"rebate":null,"swapAcceptId":null,"isSpecialItem":false,"distributor":"FoodBAM- GI","shoppingCartId":1148310,"isPriceOutdated":0,"isMarketPrice":0,"din":"61657 ","isPunchedOut":0,"belongsToGroup":1,"parLevel":null,"onHand":null,"isPartner":1,"isPurchased":1,"lastPurchasedDate":"15/01/2020","lastPurchasedQty":1,"savings":null,"priceTotalRow":"$9.34"}],"dataDistributor":{"id":531,"organizationId":78308,"nickname":"FoodBAM- GI","regionName":"","enabled":0,"timezone":-8,"availabilityCutOffTime":"16:00:00","foodbuyId":"","fairPricingToAll":1,"showDeliveryDates":1,"defaultDeliveryDays":2,"deliveryDates":["Today, 03/20/20","2020-03-23","2020-03-24","2020-03-25","2020-03-26","2020-03-27","2020-03-30","2020-03-31","2020-04-01","2020-04-02","2020-04-03","2020-04-06","2020-04-07","2020-04-08","2020-04-09","2020-04-10"],"acceptACH":0,"acceptCC":2,"isDelivery":1,"foodbam_markup_type":1,"foodbam_markup":15,"delivery_fee":null,"delivery_fee_type":0,"same_day_delivery_fee":50,"same_day_delivery_fee_type":0,"dsrEmail":"ashley@foodbam.com","credit":0,"isMinOrderAmountRequired":1,"isMinCaseRequired":0,"skipMinOrder":false,"minOrderAmount":200,"isOrderApprovalRequestSent":0,"isSameDayDelivery":1,"isFirstOrderOfTheDay":1,"caseMinimum":0,"softMinimum":0,"payableTerms":null,"locationIds":[{"id":23053,"merchantId":26992,"distributorId":null,"updateTime":null,"acceptCC":null,"acceptACH":null},{"id":67829,"merchantId":28841,"distributorId":null,"updateTime":null,"acceptCC":null,"acceptACH":null},{"id":67857,"merchantId":45320,"distributorId":null,"updateTime":null,"acceptCC":null,"acceptACH":null}]},"priceTotalCard":"$222.62","paymentMethod":{"type":"credit_card","token":"","card":{"isDefault":1,"nickname":"asdf222","token":"card_1GEkMYAOyv46Sv907gmBad8a","cardType":"visa","last4":4242,"checked":true}},"deliveryDetail":{"valueDeliveryDate":"2020-03-23","valueDeliveryTime":"9am - 1pm","valueNote":"ok"}}`);
    const { getCartItems } = useShoppingCart.useCartItems();

    const dispatch = useDispatch()
    const useOrdersApi = useReviewOrder.useOrdersApi();

    useEffect(() => {

        if (headerIndex == 3) {
            history.push('/checkout-ordering/review-order')
        } else if (headerIndex == 6) {
            // getCards();
        }
    }, [headerIndex])


    const openModalProcessing = () => {
        const props = {
            header: 'Order Processing...'
        };
        dispatch(showModal(LoaderModal, props));
    }


    const openModalConfirm = () => {
        const props = {
            header: 'Confirmation',
            message: `Foodbam order for ${valuesCheckout.dataDistributor.nickname} Submitted`,

            onOk: () => {
                dispatch(saveHeaderIndexRevOrder(3));
            }
        };
        dispatch(showModal(ConfirmationModal, props));
    }

    const submit = () => {
        // dispatch(spinner(true));
        // openModalProcessing();
        useOrdersApi.useSaveOrder(valuesCheckout)
            .then(res => {
                // dispatch(spinner(false));
                // setTimeout(() => {
                openModalConfirm();
                getCartItems();
                // }, 500);
            })
            .catch(error => {
                let message = 'Something went wrong while processing the order.';
                if(error.data){
                  message = error.data.message;
                }
                const props = {
                    message: message,
                    onOk: () => {
                        // history.push('/logout');
                    }
                };
                dispatch(showModal(AlertModal, props));
            });

    }

    return (
        <div className="contentOrdering contentRow">
            <ShowIf show={valuesCheckout}>
                <FinalReviewRow
                    values={valuesCheckout}
                    submit={submit}
                />
            </ShowIf>
        </div>
    )
}

export default FinalReview
